import { render, staticRenderFns } from "./AccessGroups.vue?vue&type=template&id=39c0f33e&scoped=true"
import script from "./AccessGroups.vue?vue&type=script&lang=js"
export * from "./AccessGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c0f33e",
  null
  
)

export default component.exports